function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_attention_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h100v100H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon_attention_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "\\u9577\\u65B9\\u5F62 2167",
  fill: "none",
  d: "M0 0h100v100H0z"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2321",
  fill: "#68b7e6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M83.043 95H16.148C9.48 95 4.137 92.333 1.635 88.333c-2.669-4.667-2-10.333 1.5-16l33.2-58C40.003 8.167 44.674 5 49.846 5s9.842 3.167 13.512 9.333l33.7 58a16.187 16.187 0 011.5 16C95.554 92.333 90.38 95 83.043 95zM49.846 10.167c-3.17 0-6.172 2.667-8.841 6.667l-33.7 57.5c-2 4.667-2.669 8.333-1 11.333 1.5 2.667 5.171 4.167 9.842 4.167h66.896c4.671 0 8.341-1.5 9.842-4.167s1-6.667-1.5-10.833l-32.7-58c-2.667-4.001-5.67-6.667-8.839-6.667z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\u30D1\\u30B9 1614",
  d: "M45.012 73.833a4.654 4.654 0 001.333 3.333 4.955 4.955 0 003.334 1.334 4.654 4.654 0 003.333-1.333 4.833 4.833 0 00-3.5-8.167 4.78 4.78 0 00-4.5 4.833z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\u30D1\\u30B9 1615",
  d: "M49.846 64.167c2.833 0 4.833-18.167 4.833-27.667a4.947 4.947 0 00-4.833-4.833h-.167a4.837 4.837 0 00-4.833 4.833c.167 8.167 2 27.667 5 27.667z"
})));

var SvgIconAttention = function SvgIconAttention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100
  }, props), _ref, _ref2);
};

export default SvgIconAttention;